// import Vue from 'vue/dist/vue.js';
const axios = require('axios');

// Vue.config.productionTip = false;

export default {
    name: 'fomie-form-claim',
    _selector : '.js_formie-reg_number',

    init() {
        const el = document.querySelector(this._selector);

        if (el) {
            el.addEventListener('change', this.getVehicleId);
        }

        const repeater = document.querySelector('.fui-repeater-add-btn');

        if (repeater) {
            // add event listener & callback functions to repeater btn
            repeater.addEventListener('click', () => {
                this.listenToExpectedSolution();
                this.hideOrShowCheckedSolutions();
                this.listenToRepeaterProblemLocationDetails();
                this.hideOrShowProblemLocationDetails();
            });

            // add event listeners to radio inputs when go back & forward in form
            this.listenToExpectedSolution();
            this.listenToRepeaterProblemLocationDetails();
        }

        // handle visibility on load
        this.hideOrShowCheckedSolutions();
        this.hideOrShowProblemLocationDetails();
    },

    hideOrShowProblemLocationDetails()
    {
        setTimeout(() => {
            // console.log('hideOrShowProblemLocationDetails');
            const radioButtons = document.querySelectorAll(`div[data-field-handle="problem_location_detail"] input:checked`);
            // console.log(radioButtons.length);

            if (radioButtons.length) {
                radioButtons.forEach((input) => {
                    const problemLocation = input.value.toLowerCase();

                    const fieldContainer = input.closest(".fui-field-rows");

                    const targets = {
                        'innvendig' : 'problem_location_detail_inside',
                        'utvendig' : 'problem_location_detail_outside',
                        'motor_drivverk' : 'problem_location_detail_engine'
                    };

                    const showTarget = targets[problemLocation];

                    // handle unselected targets #1
                    for (let attr in targets) {
                        if (attr !== problemLocation) {
                            let dropDownFieldContainer = fieldContainer.querySelector(`div[data-field-handle='${targets[attr]}']`);

                            if (dropDownFieldContainer) {
                                dropDownFieldContainer.style.display = 'none';
                                dropDownFieldContainer.querySelector(`select`).value = 'annet';
                            }
                        }
                    }

                    // handle visibility
                    fieldContainer.querySelector(`div[data-field-handle='${showTarget}']`).style.display = 'block';

                    // handle values
                    const showSelect = fieldContainer.querySelector(`div[data-field-handle='${showTarget}'] select`);
                    if (showSelect.value.length === 0 || showSelect.value === 'annet') {
                        showSelect.value = showSelect.options[0].value;
                    }

                });
            }
        }, 1000);
    },

    listenToRepeaterProblemLocationDetails()
    {
        setTimeout(() => {
            // console.log('listenToRepeaterProblemLocationDetails');
            const radioButtons = document.querySelectorAll('div[data-field-handle=problem_location_detail] input');

            if (radioButtons.length) {
                radioButtons.forEach((input) => {
                    input.addEventListener('click', (e) => {
                        const problemLocation = e.target.value.toLowerCase();

                        const fieldContainer = input.closest(".fui-field-rows");

                        const targets = {
                            'innvendig' : 'problem_location_detail_inside',
                            'utvendig' : 'problem_location_detail_outside',
                            'motor_drivverk' : 'problem_location_detail_engine'
                        };

                        const showTarget = targets[problemLocation];

                        // handle unselected targets #1
                        for (let attr in targets) {
                            if (attr !== problemLocation) {
                                let dropDownFieldContainer = fieldContainer.querySelector(`div[data-field-handle='${targets[attr]}']`);

                                if (dropDownFieldContainer) {
                                    dropDownFieldContainer.style.display = 'none';
                                    dropDownFieldContainer.querySelector(`select`).value = 'annet';
                                }
                            }
                        }

                        // handle visibility
                        fieldContainer.querySelector(`div[data-field-handle='${showTarget}']`).style.display = 'block';

                        // handle values
                        const showSelect = fieldContainer.querySelector(`div[data-field-handle='${showTarget}'] select`);
                        if (showSelect.value.length === 0 || showSelect.value === 'annet') {
                            showSelect.value = showSelect.options[0].value;
                        }

                    });
                });
            }
        }, 1000);
    },

    listenToExpectedSolution()
    {
        setTimeout(() => {
            const radioButtons = document.querySelectorAll(`div[data-field-handle="problem_expected_solution"] input`);

            // console.log('listenToExpectedSolution');
            // console.log(radioButtons.length);

            if (radioButtons.length) {
                radioButtons.forEach((input) => {
                    // console.log(input);
                    input.addEventListener('click', (e) => {
                        //  console.log(e.target);
                        // console.log(e.target.value);

                        // find closest field container
                        const fieldContainer = e.target.closest(".fui-field-rows");

                        let value = ' ';
                        let display = (fieldContainer && e.target.value.toLowerCase() === 'annet') ?
                            'block' :
                            'none';

                        fieldContainer.querySelector("div[data-field-handle='problem_expected_solution_desc']").style.display = display;
                        fieldContainer.querySelector("div[data-field-handle='problem_expected_solution_desc'] input").value = value;
                    });
                });
            }
        }, 1000);
    },

    hideOrShowCheckedSolutions()
    {
        // console.log('hideOrShowCheckedSolutions');
        setTimeout(() => {
            const radioButtons = document.querySelectorAll(`div[data-field-handle="problem_expected_solution"] input:checked`);

            if (radioButtons.length) {
                radioButtons.forEach((input) => {
                    const fieldContainer = input.closest(".fui-field-rows");
                    let display = 'none';
                    if (fieldContainer && input.value.toLowerCase() === 'annet') {
                        display = 'block'
                    }

                    fieldContainer.querySelector("div[data-field-handle='problem_expected_solution_desc']").style.display = display;

                    const textInput = fieldContainer.querySelector("div[data-field-handle='problem_expected_solution_desc'] input");
                    if (textInput.value.length === 0) {
                        textInput.value = ' ';
                    }
                });
            }
        }, 1000);
    },

    getVehicleId(event)
    {
        const el = document.getElementById(event.target.id);

        if (! el) {
            return false;
        }

        el.value = el.value.replaceAll(' ', '');
        const value = el.value;

        const url = `/actions/mm/regnr/get-vehicle?reg_number=${value}`;
        axios.get(url)
            .then((response) => {
                let vehicleId = '';

                // RK94541
                if (response.data.item && typeof response.data.item === 'object') {
                    // console.log('response.data.item');
                    // console.log(response.data.item);
                    const data = {
                        resource : response.data.item.resource,
                        brand : response.data.item.merkenavn,
                        model : response.data.item.modell,
                        reg_number : response.data.item.kjennemerke,
                        chassis_no : response.data.item.understellsnummer,
                        registered_at : response.data.item.f_g_n,
                    };

                    // console.log(data);
                    for (const [key, value] of Object.entries(data)) {
                        let hf = document.querySelector(`input[data-fui-id="complaints-object_${key}"]`);
                        // console.log(`${key}: ${value}`);
                        if (hf) {
                            hf.value = value;
                        }
                    }

                    vehicleId = `Merke ${data.brand} \n Modell: ${data.model} \n Reg.nr. ${data.reg_number} \n VIN-nummer: ${data.chassis_no} \n  Registrert: ${data.registered_at}`;
                }

                const target = document.querySelector('div[data-field-handle="vehicle_summary"]');

                // console.log('vehicleId');
                // console.log(vehicleId);
                if (target) {
                    target.innerText = vehicleId;
                }
            })
            .catch(function (error) {});
    },



}